import React from 'react'
import { dark_close } from '../../assets/images'
import CircularProgressBar from '../common/molecules/CircularProgressBar'

function DownloadCircularProgressModel({visible = '', icon= '', width = '', height = '', title, dashArray = [], description, btnText, btnClasses, onCancel = () => {} , handler = () => {} }) {
  return (
    <div
    className={`fixed z-20 inset-0 overflow-y-auto ${ visible ? '' : 'hidden'}`}
    aria-labelledby='modal-title'  
    aria-modal='true'
  >
    <div className='flex items-end justify-center  text-center sm:block sm:p-0'>
      <div
        className='fixed inset-0 bg-gray-900 bg-opacity-25 transition-opacity'
        aria-hidden='true'
        onClick={onCancel}
      >
      </div>
      <span className='sm:inline-block sm:align-middle sm:h-screen' aria-hidden='true'>
        &#8203;
      </span>  
      <div className="inline-block  align-middle justify-center text-center bg-white overflow-hidden shadow-xl transform transition-75 sm:my-8 sm:align-middle sm:max-w-3xl sm:w-full"
      style={{zIndex : 1000, borderRadius : '10px', width : width, height: height}}
      >
        <div className="bg-white px-4 pb-4 sm:p-8 sm:pb-4">
          <div className='flex flex-row-reverse'>
            <img src={dark_close} alt='closeIcon' className='cursor-pointer' onClick={onCancel} />
          </div>   
          <div className='px-9 ' >
            <div className="text-center sm:mt-0 sm:ml-4"   >
              <div className="w-full">
                { icon ? <img  src={icon}  style={{marginLeft : '180px', marginBottom : '32px',  height: '60px', width:'60px', }} /> :  <CircularProgressBar  styleCss={{marginLeft : '120px', marginBottom:'16px'}} show={false} DashArray={dashArray} />}
              </div>
              <h3 className='text-xl leading-6 font-bold  text-gray-700 ' id='modal-title'>
                  {title}
              </h3>    
              <p className='text-base font-normal text-gray-600 ' >
                {description}
              </p>   
            </div>
            <button
              type="button"
              className={`text-base font-semibold rounded-md  px-6 py-2 w-18.25 h-11 mt-3 ${btnClasses}`}
              onClick={handler}
              >
                {btnText}
          </button>
          </div>
        </div>
      </div>
    </div>
  </div>   
  )
}

export default DownloadCircularProgressModel